export const gestaoMunicipios = [
  {
    name: `Encontros`,
    config: "visualizaTodosEncontros",
    configPai: "encontros",
    link: "/encontros",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Municípios ADs",
    config: "verMenuMunicipiosAds",
    link: "/municipioAds",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Municípios Eixos",
    config: "verMenuMunicipioEixos",
    link: "/municipioEixo",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Municípios Temas",
    config: "verMenuMunicipioTemas",
    link: "/municipioTemasHabilitados",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Meus Encontros",
    config: "encontros",
    link: "/encontros",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
];

export const cadastros = [
  {
    name: "Unidades Regionais",
    config: "unidadesRegionais",
    link: "/ur",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Contratos",
    config: "verMenuContrato",
    link: "/contratos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Temas",
    config: "temas",
    link: "/tema",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Eixos",
    config: "eixos",
    link: "/eixos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Pacotes",
    config: "pacotes",
    link: "/pacote",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Perguntas",
    config: "perguntas",
    link: "/pergunta",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Medalhas",
    config: "medalas",
    link: "/medalha",
    isMobile: true,
    icon: "mdi-file-document-box",
  },

  {
    name: "Eventos",
    config: "eventos",
    link: "/eventos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Categorias",
    config: "verMenuCategorias",
    link: "/categorias",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Instituição",
    config: "verMenuInstituicao",
    link: "/instituicao",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Faixas",
    config: "verMenuFaixas",
    link: "/faixas",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
];

export const menus = [
  {
    name: "Gestão de Territórios",
    link: "gestao-territorios/territorios",
    config: "menuGestaoTerritorios",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Educação Empreendedora",
    config: "verEducacaoEmpreendedora",
    link: "/municipio-escola",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Gestão de Municípios",
    link: "",
    config: "",
    children: gestaoMunicipios,
  },
  {
    name: "Gestão de Cadastros",
    link: "",
    config: "",
    children: cadastros,
  },
];

export const configs = [
  {
    name: "ORÇAMENTO",
    config: "isFullAdmin",
    link: "/orcamento",
    isMobile: true,
    icon: "mdi-finance",
  },
  {
    name: "Configurações",
    config: "configuracao",
    link: `/configuracoes`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Grupos",
    config: "grupo",
    link: `/groups`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Projetos e Soluções",
    config: "projetoseSolucoes",
    link: "/termo-referencia",
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Processos de pagamentos",
    config: "processosPagamentos",
    link: "/gestao-pagamento",
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Tipo Solução",
    config: "editarTipoSolucao",
    link: "/tipoSolucao",
    isMobile: true,
    icon: "mdi-settings",
  },

  {
    name: "Meus Processos de Pagamentos",
    config: "meusProcessosPagamentos",
    link: `/gestao-pagamento/usuario/userId`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Sala do Empreendedor",
    config: "salaEmpreendedor",
    link: `/sala-principal`,
    isMobile: true,

    icon: "mdi-settings",
  },
  {
    name: "Usuários",
    config: "usuarios",
    link: "/usuario",
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "EC2 Codex",
    config: "isFullAdmin",
    link: "/ec2-codex",
    isMobile: true,
    icon: "mdi-server",
  },
  {
    name: "Painel IA - IAN",
    config: "paineliaian",
    link: "/ia-coleta-evidencias/painel",
    isMobile: true,
    icon: "mdi-robot",
  },
  {
    name: "Análise de Evidências - IA",
    config: "analiseEvidenciasIa",
    link: "/analise-evidencias-ia/painel",
    isMobile: true,
    icon: "mdi-clipboard-search",
  },
  {
    name: "Análise de Evidências - IA - Validação",
    config: "analiseEvidenciasIaValidacao",
    link: "/analise-evidencias-ia/validacao",
    isMobile: true,
    icon: "mdi-clipboard-check",
  },
];

export const relatorios = [
  {
    name: "Relatórios do Ciclo",
    config: "relatoriosCicloSelo",
    relatoriosCicloOnly: true,
    link: "/selo/relatorios-ciclo",
    isMobile: true,
    icon: "mdi-file-chart",
  },
  {
    name: "Analisar Relatórios",
    config: "podeAnalisarRelatorio",
    link: "/analisar-relatorios",
    configPai: "analisarRelatorios",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Meus Relatórios",
    config: "verMeusRelatorios",
    link: "/analisar-relatorios",
    configPai: "analisarRelatorios",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Validação IA de Relatórios",
    config: "analiseRelatoriosIaValidacao",
    link: "/analise-relatorios-ia/validacao",
    requireExplicitPermission: true,
    isMobile: true,
    icon: "mdi-clipboard-check-outline",
  },

  {
    name: "Analisar Relatórios Admin",
    config: "analisarRelatoriosAdministrativos",
    link: "/analisar-relatorios-administrativos",
    configPai: "analisarRelatoriosAdministrativos",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },

  {
    name: "Meus Relatórios Admin",
    config: "verMenuMeusRelatoriosAdmin",
    link: "/analisar-relatorios-administrativos",
    configPai: "analisarRelatoriosAdministrativos",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Dashboard",
    config: "dashboardAdministrativo",
    link: "/dashboard-administrativo2",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "News",
    config: "cidadeEmpreendedoraNews",
    link: "/cidade-empreendedora-news",
    isMobile: true,
    icon: "mdi-newspaper-variant-outline",
  },
  {
    name: "Painel de Indicadores Estadual",
    config: "painelIndicadoresEstadual",
    externalLinkType: "painelIndicadoresEstadual",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Infográfico da UF",
    config: "infograficoUf",
    externalLinkType: "infograficoUf",
    isMobile: true,
    icon: "mdi-chart-areaspline",
  },
  {
    name: "Painel de Indicadores Nacional",
    config: "painelIndicadoresNacional",
    externalLinkType: "painelIndicadoresNacional",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Painel de Execução",
    config: "painelExecucao",
    externalLinkType: "painelExecucao",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Radar de Execução",
    config: "radarExecucao",
    radarExecucaoOnly: true,
    link: "/radar-execucao",
    isMobile: true,
    icon: "mdi-radar",
  },
];

export const buildPainelExternalLink = (type, uf) => {
  const siglaUf = String(uf || "")
    .trim()
    .toLowerCase();

  if (type === "painelIndicadoresNacional") {
    return "https://painel.desenvolvimentoterritorial.com.br";
  }

  if (!siglaUf) return "";

  const painelEstadualUrl = `https://painel-${siglaUf}.desenvolvimentoterritorial.com.br`;

  if (type === "painelIndicadoresEstadual") {
    return painelEstadualUrl;
  }

  if (type === "infograficoUf") {
    return `https://painel-${siglaUf}.cidadeempreendedora.com.br/#/indicadores/visao-uf`;
  }

  if (type === "painelExecucao") {
    return `${painelEstadualUrl}/#/indicadores/execucao`;
  }

  return "";
};

export const menu = [
  {
    name: "Início",
    link: "/cidade",
  },
  {
    name: "Gestão",
    children: menus,
    link: "",
  },
  {
    name: "Compras públicas · ObservaGov",
    link: "/observagov/compras",
    scHlgOnly: true,
    isMobile: true,
    icon: "mdi-file-document-multiple",
  },
  {
    name: "Recursos do Estado",
    link: "/painel-recursos",
    config: "painelRecursosEstado",
    isMobile: true,
    icon: "mdi-file-chart",
  },
  {
    name: "Revisões Técnicas do Estado",
    link: "/painel-revisoes-tecnicas",
    config: "painelRevisaoTecnicaEstado",
    isMobile: true,
    icon: "mdi-file-chart",
  },
  {
    name: "Fechamento do Selo",
    link: "/selo/fechamento",
    config: "fechamentoSelo",
    seloFechamentoOnly: true,
    isMobile: true,
    icon: "mdi-lock-check",
  },

  {
    name: "Administração",
    children: configs,
    link: "",
  },
  {
    name: "Relatórios",
    children: relatorios,
    link: "",
  },
];
